// @ts-ignore
import { getAllPaymentModes, getAllPaytmTerminalsByCenterId, intitiatePaytmPayment } from "core/services/api";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import Toast from "components/Toast";
import { useSelector } from "react-redux";

// @ts-ignore
function PaymentRows({
  paymentDetails,
  deleteTableRows,
  handlePaymentChange,
  invoice,
  setPaymentType,
  addTablePaymentRows,
  setTrustName,
  trustName,
  setShowCheckStatusModal,
  setPaytmPaymentTransactionCallBack }: any) {
  // @ts-ignore

  const [payDropdownType, setPayDropdownType] = useState<any>([]);
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const centerId = userDetail?.currentCenter?.centerId
  const [paymentDropdown, setPaymentDropdown] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [paytmTerminalDropdownOptions, setPaytmTerminalDropdownOptions] = useState<any>([]);
  const [paytmTerminalId, setPaytmTerminalId] = useState<any>();
  const [success, setSuccess] = useState<boolean>(false)
  const [message, setMessage] = useState<string>("")
  const [toastType, setToastType] = useState<string>("")

  useEffect(() => {
    getAllPaymentModes()
      .then((res: any) => {
        console.log(res?.paymentMode, "payment mode response");
        const temp = res?.paymentMode?.map((values: any) => {
          return {
            label: values,
            value: values,
          }
        })
        setPaymentDropdown(temp);
      })
      .catch((err: any) => {
        console.log("err", err)
      })
  }, [])

  useEffect(() => {
    if (payDropdownType.includes("POS MACHINE")) {
      getAllPaytmTerminalsByCenterId(centerId, invoice?.appointmentType)
        .then((res: any) => {
          const temp = res?.map((item: any) => {
            return {
              label: item.name,
              value: item.id,
              default: item.isDefault
            }
          })
          setPaytmTerminalDropdownOptions(temp);
          const defaultTerminal = temp.find((option: any) => option.default);
          if (defaultTerminal) {
            setPaytmTerminalId(defaultTerminal.value);
          }
          setIsLoading(false);
        })
        .catch((err: any) => {
          console.log("err", err)
          setIsLoading(false);
          setMessage(err?.response?.data?.message || "Error fetching Paytm terminals");
          setSuccess(true);
          setToastType("error");
        })
    }
  }, [payDropdownType])

  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const isOptionDisabled = (option: any) => {
    return selectedOptions.some((selectedOption: any) => selectedOption === option.value);
  };

  const deleteSelectedOptions = (index: any) => {
    const newArray = [...selectedOptions];
    newArray.splice(index, 1)
    setSelectedOptions(newArray);

  }

  const getPaytmErrorMessage = (resultCode: string, resultMsg: string): string => {
    const errorMap: { [key: string]: string } = {
      '0009': 'Payment request accepted successfully',
      '0330': 'Invalid payment request, please try again',
      '1809': 'Transaction amount exceeds the allowed limit',
      '1810': 'Invalid display information',
      '0007': 'Terminal is inactive, please contact support',
      '0333': 'Terminal is busy, please try again after some time',
      '0002': 'Invalid request parameters',
      '0012': 'System error occurred, please try again',
      '0022': 'Merchant account is blocked',
      '0029': 'Invalid Merchant or Device details',
      '0233': 'Duplicate transaction, please try with different order',
      '9001': 'Merchant configuration error, please contact support',
      '0902': 'Merchant account is blocked, please contact support',
      '1825': 'Please contact support',
      '1815': 'Invalid timeout configuration, please contact support',
      '1813': 'Invalid split parameters, please contact support',
      '1814': 'Invalid timeout configuration for transaction, please contact support'
    };

    return errorMap[resultCode] || resultMsg || 'Error initiating paytm payment, please contact support';
  };

  const handleInitiatePaytmPayment = (transactionAmt: any, paytmTerminal: any) => {
    setIsLoading(true);
    intitiatePaytmPayment(centerId, paytmTerminal, { amount: transactionAmt, invoiceId: invoice?.id, paymentType: "INVOICE" })
      .then((res: any) => {
        setPaytmPaymentTransactionCallBack(res);
        setIsLoading(false);
        if (res?.data?.resultStatus !== "ACCEPTED_SUCCESS") {
          const errorCode = res?.data?.resultCode;
          const errorMsg = res?.data?.resultMsg;
          const paytmErrorMessage = getPaytmErrorMessage(errorCode, errorMsg);
          setMessage(paytmErrorMessage);
          setSuccess(true);
          setToastType("error");
          return;
        }
      })
      .catch((err: any) => {
        setIsLoading(false);
        const errorCode = err?.response?.data?.resultCode;
        const errorMsg = err?.response?.data?.message;
        const paytmErrorMessage = getPaytmErrorMessage(errorCode, errorMsg);
        setMessage(paytmErrorMessage);
        setSuccess(true);
        setToastType("error");
      });
  }

  return paymentDetails.map((data: any, index: any) => {
    const {
      transactionId,
      transactionAmt,
      modeOfPayment,
      companyName,
      bankName,
      cardNumber,
      chequeNo,
      tpaName,
      remarks
    } = data


    console.log("paymentDropdown", paymentDropdown, payDropdownType[index]);

    return (
      <>
        <table className="table align-top">
          <thead>
            <tr>
              <th>Payment Mode</th>
              <th>Transaction Amount</th>
              {payDropdownType[index] === "POS MACHINE" ? <>
                <th>Paytm Device</th>
                <th>Action</th>
              </> : <></>}

              {payDropdownType[index] === "CHEQUE" ? <>
                <th>Bank Name</th>
                <th>Cheque No</th>
                <th>Name</th>
                <th>Remarks</th>
              </> : <></>}
              {payDropdownType[index] === "CASH" || payDropdownType[index] === "WAIVE OFF" || payDropdownType[index] === "CLINICAL RESEARCH" || payDropdownType[index] === "PRACTO" ? <>
                <th>Name</th>
                <th>Remarks</th>
              </> : <></>}
              {payDropdownType[index] === "CARD" ? <>
                <th>Card Number(Last 4 digit)</th>
                <th>Transaction ID</th>
                <th>Name</th>
                <th>Remarks</th>
              </> : <></>}
              {payDropdownType[index] === "NEFT" ? <>
                <th>Bank Name</th>
                <th>Transaction ID</th>
                <th>Name</th>
                <th>Remarks</th>
              </> : <></>}
              {payDropdownType[index] === "RTGS" ? <>
                <th>Bank Name</th>
                <th>Transaction ID</th>
                <th>Name</th>
                <th>Remarks</th>
              </> : <></>}
              {payDropdownType[index] === "INSURANCE" ? <>
                <th>TPA Name</th>
                <th>Transaction ID</th>
                <th>Name</th>
                <th>Remarks</th>
              </> : <></>}
              {payDropdownType[index] === "PAYTM/GPAY/UPI/PHONEPAY"
                ? <>
                  <th>Transaction ID</th>
                  <th>Name</th>
                  <th>Remarks</th>
                </> : <></>}
              {payDropdownType[index] === "CGHS" || payDropdownType[index] === "CORPORATE" || payDropdownType[index] === "PSU" || payDropdownType[index] === "GOVERNMENT SCHEMES"
                ? <>
                  <th>Company Name</th>
                  <th>Transaction ID</th>
                  <th>Name</th>
                  <th>Remarks</th>
                </> : <></>}

            </tr>
          </thead>
          <tbody>
            <tr key={index}>
              <td>
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  className="select-payment"
                  name="modeOfPayment"
                  options={paymentDropdown}
                  isOptionDisabled={isOptionDisabled}
                  onChange={(evnt) => {
                    const newArray = [...selectedOptions];
                    newArray[index] = evnt?.label;
                    setSelectedOptions(newArray);
                    const newPaymentMode = [...payDropdownType]
                    newPaymentMode[index] = evnt?.value
                    setPayDropdownType(newPaymentMode);
                    handlePaymentChange(index, evnt)
                  }}
                />

              </td>
              <td>
                <input
                  type="text"
                  placeholder="TransactionAmt"
                  value={transactionAmt}
                  onChange={(evnt) => handlePaymentChange(index, evnt)}
                  name="transactionAmt"
                  className={`form-control ${(transactionAmt > 100000) ? "border border-danger" : ""}`}
                />{" "}
                <div className="text-danger mt-1">{(transactionAmt > 100000) ? "Transaction Amount is more than 1 lakh" : ""}</div>
              </td>
              {payDropdownType[index] === "CHEQUE" ? (<>
                <td>
                  <input
                    type="text"
                    placeholder="BankName"
                    value={bankName}
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="bankName"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={chequeNo}
                    placeholder="Cheque Number"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="chequeNo"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={trustName}
                    placeholder="Name"
                    onChange={(e) => {
                      setTrustName(e.target.value)
                    }}
                    name="trustName"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={remarks}
                    placeholder="Remarks"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="remarks"
                    className="form-control"
                  />{" "}
                </td>
              </>) : (<></>)}
              {/* payment type pos */}
              {payDropdownType[index] === "POS MACHINE" ? <>
                <td>
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    className="select-payment"
                    placeholder="Select Terminal"
                    options={paytmTerminalDropdownOptions}
                    value={paytmTerminalDropdownOptions.find((option: any) => option.value === paytmTerminalId)}
                    onChange={(option: any) => {
                      setPaytmTerminalId(option.value)
                    }}
                  />{" "}
                </td>
                <td>
                  <Button
                    variant="primary"
                    className="submission-button"
                    disabled={isLoading || Number(transactionAmt) === 0 || !paytmTerminalId}
                    onClick={() => {
                      handleInitiatePaytmPayment(transactionAmt, paytmTerminalId)
                    }}
                  >
                    Initiate Payment
                  </Button>
                </td>
              </> : <></>}

              {/* payment type card */}
              {payDropdownType[index] === "CARD" ? <>
                <td>
                  <input
                    type="number"
                    value={cardNumber}
                    placeholder="Card Number"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="cardNumber"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={transactionId}
                    placeholder="Transaction ID"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="transactionId"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={trustName}
                    placeholder="Name"
                    onChange={(e) => {
                      setTrustName(e.target.value)
                    }}
                    name="trustName"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={remarks}
                    placeholder="Remarks"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="remarks"
                    className="form-control"
                  />{" "}
                </td>
              </> : <></>}
              {/* payment type NEFT */}
              {payDropdownType[index] === "NEFT" ? <>
                <td>
                  <input
                    type="text"
                    placeholder="BankName"
                    value={bankName}
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="bankName"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={transactionId}
                    placeholder="Transaction ID"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="transactionId"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={trustName}
                    placeholder="Name"
                    onChange={(e) => {
                      setTrustName(e.target.value)
                    }}
                    name="trustName"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={remarks}
                    placeholder="Remarks"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="remarks"
                    className="form-control"
                  />{" "}
                </td>

              </> : <></>}
              {/* payment type RTGS */}
              {payDropdownType[index] === "RTGS" ? <>
                <td>
                  <input
                    type="text"
                    placeholder="BankName"
                    value={bankName}
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="bankName"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={transactionId}
                    placeholder="Transaction ID"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="transactionId"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={trustName}
                    placeholder="Name"
                    onChange={(e) => {
                      setTrustName(e.target.value)
                    }}
                    name="trustName"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={remarks}
                    placeholder="Remarks"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="remarks"
                    className="form-control"
                  />{" "}
                </td>

              </> : <></>}
              {/* payment type RTGS */}
              {payDropdownType[index] === "PAYTM/GPAY/UPI/PHONEPAY" ? <>
                <td>
                  <input
                    type="text"
                    value={transactionId}
                    placeholder="Transaction ID"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="transactionId"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={trustName}
                    placeholder="Name"
                    onChange={(e) => {
                      setTrustName(e.target.value)
                    }}
                    name="trustName"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={remarks}
                    placeholder="Remarks"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="remarks"
                    className="form-control"
                  />{" "}
                </td>
              </> : <></>}
              {payDropdownType[index] === "INSURANCE" ? <>

                <td>
                  <input
                    type="text"
                    value={tpaName}
                    placeholder="TPA Name"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="tpaName"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={transactionId}
                    placeholder="Transaction ID"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="transactionId"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={trustName}
                    placeholder="Name"
                    onChange={(e) => {
                      setTrustName(e.target.value)
                    }}
                    name="trustName"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={remarks}
                    placeholder="Remarks"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="remarks"
                    className="form-control"
                  />{" "}
                </td>

              </> : <></>}
              {payDropdownType[index] === "CASH" || payDropdownType[index] === "WAIVE OFF" || payDropdownType[index] === "CLINICAL RESEARCH" || payDropdownType[index] === "PRACTO" ? <>
                <td>
                  <input
                    type="text"
                    value={trustName}
                    placeholder="Name"
                    onChange={(e) => {
                      setTrustName(e.target.value)
                    }}
                    name="trustName"
                    className="form-control"
                  />{" "}
                </td>
                <td>
                  <input
                    type="text"
                    value={remarks}
                    placeholder="Remarks"
                    onChange={(evnt) => handlePaymentChange(index, evnt)}
                    name="remarks"
                    className="form-control"
                  />{" "}
                </td>
              </> : <></>}
              {/* payment type CGHS, Corporate, PSU */}
              {payDropdownType[index] === "CGHS" || payDropdownType[index] === "CORPORATE" || payDropdownType[index] === "PSU" || payDropdownType[index] === "GOVERNMENT SCHEMES" ?
                <>
                  <td>
                    <input
                      type="text"
                      placeholder="Company Name"
                      value={companyName}
                      onChange={(evnt) => handlePaymentChange(index, evnt)}
                      name="companyName"
                      className="form-control"
                    />{" "}
                  </td>
                  <td>
                    <input
                      type="text"
                      value={transactionId}
                      placeholder="Transaction ID"
                      onChange={(evnt) => handlePaymentChange(index, evnt)}
                      name="transactionId"
                      className="form-control"
                    />{" "}
                  </td>
                  <td>
                    <input
                      type="text"
                      value={trustName}
                      placeholder="Name"
                      onChange={(e) => {
                        setTrustName(e.target.value)
                      }}
                      name="trustName"
                      className="form-control"
                    />{" "}
                  </td>
                  <td>
                    <input
                      type="text"
                      value={remarks}
                      placeholder="Remarks"
                      onChange={(evnt) => handlePaymentChange(index, evnt)}
                      name="remarks"
                      className="form-control"
                    />{" "}
                  </td>

                </> : <></>}
              <td></td>
            </tr>
          </tbody>
        </table>
        {success ? (
          <><div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9998,
            }}
          >
          </div>
            <Toast
              textMessage={message}
              onCloseText={"Close"}
              onClose={() => {
                setSuccess(false)
                setShowCheckStatusModal(false)
                if (toastType === "success") {
                  setPaymentType(undefined)
                }
              }}
              type={toastType}
            ></Toast></>
        ) : isLoading ? (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        ) : (
          ""
        )}
      </>
    )
  })
}
export default PaymentRows
